// extracted by mini-css-extract-plugin
export default {"wrapper":"styles-module--wrapper--3qG2t","BGMask":"styles-module--BGMask--wsuWJ"};